import { Link } from "react-router-dom"

export default function ContactSection() {

  return (

    <section className="py-24 bg-[#f8f5f1] px-6">

      <div className="max-w-6xl mx-auto text-center">

        <h2 className="text-4xl font-serif mb-6">
          Prenota una consulenza personalizzata
        </h2>

        <p className="text-neutral-600 mb-10">
          Il nostro team analizzerà le tue esigenze e ti guiderà verso il trattamento più adatto.
        </p>

        <Link
          to="/consulenza"
          className="inline-flex items-center gap-3 px-10 py-4 rounded-full bg-black text-white hover:scale-105 transition"
        >
          Richiedi una consulenza
        </Link>

      </div>

    </section>

  )

}